import {
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import {useEffect, useState} from 'react';
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import { useAccount, useMsal } from "@azure/msal-react";
import { JumboCard } from "themes/jumbo/@jumbo/components";

const Contacts = () => {
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [userEmail, setUserEmail] = useState("");

  useEffect(() => {
    if (account && account.username) {
        setUserEmail(account.username);
    } else {
        setUserEmail("");
    }
  }, [account, instance]);
  return (
    <JumboCard title={"Contact"}>
      <List disablePadding sx={{ mb: 2 }}>
        <ListItem
          alignItems="flex-start"
          sx={{ p: (theme) => theme.spacing(0.5, 3) }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "text.secondary" }}>
            <EmailOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1" color="text.secondary">
                Email
              </Typography>
            }
            secondary={
              <Link variant="body1" href="#" underline="none">
                {userEmail}
              </Link>
            }
          />
        </ListItem>
        {/* <ListItem
          alignItems="flex-start"
          sx={{ p: (theme) => theme.spacing(0.5, 3) }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "text.secondary" }}>
            <InsertLinkOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1" color="text.secondary">
                Web page
              </Typography>
            }
            secondary={
              <Link variant="body1" href="#" underline="none">
                example.com
              </Link>
            }
          />
        </ListItem>
        <ListItem
          alignItems="flex-start"
          sx={{ p: (theme) => theme.spacing(0.5, 3) }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "text.secondary" }}>
            <LocalPhoneOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              <Typography variant="body1" color="text.secondary">
                Phone
              </Typography>
            }
            secondary={
              <Typography variant="body1" color="text.primary">
                +1-987 (454) 987
              </Typography>
            }
          />
        </ListItem> */}
      </List>
    </JumboCard>
  );
};

export { Contacts };
